import { render, staticRenderFns } from "./ServiceUserLogs.vue?vue&type=template&id=ab1427da"
import script from "./ServiceUserLogs.vue?vue&type=script&lang=js"
export * from "./ServiceUserLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports